import {api} from "../../src/api";
import {Notifications} from "../../src/notifications";
import {Validation} from "../../src/validation";
import {trackException} from "../../src/errors";
import {formatCurrency} from "../../src/common";

document.addEventListener("DOMContentLoaded", () => {
    const cartId = document.querySelector("#cartId").value;
    const checkoutButton = document.querySelector("#checkout");

    Handlebars.registerHelper('formatCurrency', function (value) {
        return formatCurrency(value);
    });

    //#region Add to Cart

    document.querySelectorAll("[data-add-to-cart]").forEach(el => {
        el.addEventListener("click", handleAddToCart);
    });

    document.querySelectorAll(".variations").forEach(el => {
        handleChangeVariation(el);
        el.addEventListener("change", () => {handleChangeVariation(el)});
    });

    async function handleAddToCart(e) {
        e.preventDefault();

        const el = e.currentTarget;
        const container = el.closest(".card-product");
        const variationId = container.querySelector(".variations")?.value;
        const quantity = container.querySelector(".quantity")?.value ?? 1;
        const productId = el.dataset.productId;

        if(quantity <= 0)
            return;

        let values = {
            productId: productId,
            quantity: quantity,
            variationId: variationId
        };

        try {
            el.setAttribute("data-kt-indicator", "on");

            const {data} = await api.put(`/api/cart/${cartId}`, values);

            updateCart(data);

            Notifications.showSuccess({ message: "Item added to cart." });
        }
        catch(ex) {
            trackException(ex);

            if(ex.response.data.errors[0]){
                Notifications.alert.fire({ html: ex.response.data.errors[0] });
            } else {
                Notifications.showError({ message: "There was a problem adding the item to your cart." })
            }

        } finally {
            el.removeAttribute("data-kt-indicator");
        }
    }

    function handleChangeVariation(el) {
        const productContainer = el.closest(".card-product");
        const option = el.options[el.selectedIndex];
        const dialer = productContainer.querySelector(`[data-kt-dialer="true"]`);
        const dialerObject = KTDialer.getInstance(dialer);
        const quantityInput = productContainer.querySelector(".quantity");
        const addToCartButton = productContainer.querySelector("[data-add-to-cart]");

        const stock = option.getAttribute("data-variation-stock");
        if(!stock || Number.isNaN(Number(stock))){
            dialerObject?.setMaxValue(Number(9999));
            addToCartButton?.classList.remove("disabled", "pe-none");
        } else if(stock === "0") {
            addToCartButton?.classList.add("disabled", "pe-none");
        } else {
            addToCartButton?.classList.remove("disabled", "pe-none");
            if(quantityInput?.value > stock)
                quantityInput.value = stock;

            dialerObject?.setMaxValue(Number(stock));
        }
    }

    //#endregion

    document.addEventListener("click", async (e) => {
        const target = e.target.closest("[data-delete-item]")
        if (!target)
            return;

        e.preventDefault();

        const {isConfirmed} = await Notifications.confirm.fire({
            title: "Remove Item?",
            text: "The item will be removed from your cart. This cannot be undone."
        });

        if (!isConfirmed)
            return;

        const itemId = target.dataset.itemId;

        try {
            const {data} = await api.delete(`/api/cart/${cartId}/${itemId}`);

            updateCart(data);
            Notifications.showSuccess({message: "The item has been removed."});
        } catch (ex) {
            trackException(ex);
            Notifications.showError({message: "There was a problem removing the item from your cart."})
        }
    });

    document.querySelector("#category")?.addEventListener("change", (e) => {
        document.getElementById("store_search").submit();
    });

    checkoutButton?.addEventListener("click", e => {
        Validation.disableButton(checkoutButton);
    });

    function updateCart(cart) {

        if (cart.products && cart.products.length > 0) {

            document.querySelector("#cart_items").innerHTML = productTemplate(cart);
            document.querySelector("#cart_total").innerHTML = formatCurrency(cart.total);

            checkoutButton.classList.remove("disabled", "pe-none");
        } else {
            document.querySelector("#cart_items").innerHTML = noResultsTemplate();
            document.querySelector("#cart_total").innerHTML = "";
            checkoutButton.classList.add("disabled", "pe-none");
        }
    }
});


//#region Templates

const noResultsTemplate = Handlebars.compile("<div>Your cart is empty.</div>");

const productTemplate = Handlebars.compile(`
    {{#each products}}
        <div class="d-flex justify-content-between align-items-center mb-5 border-bottom border-bottom-light-dark pb-5">
            <div class="flex-grow-1">
                <h6>{{name}}</h6>
                <div class="mb-2">{{variationName}}</div>
                <div>{{quantity}} @ {{formatCurrency cost}}</div>
            </div>
            <div class="ml-2">
                <a href="" data-delete-item data-item-id="{{id}}" class="text-dark-50 text-hover-primary"><span class="bi bi-trash text-danger fs-2"></span></a>
            </div>
        </div>
    {{/each}}
`);

//#endregion
